var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCycounterDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "88.000000pt",
    height: "31.000000pt",
    viewBox: "0 0 88.000000 31.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,31.000000) scale(0.100000,-0.100000)",
    fill: "#191a1b",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 155 l0 -155 440 0 440 0 0 155 0 155 -440 0 -440 0 0 -155z m270 105 c17 -17 20 -33 20 -105 0 -117 -9 -125 -130 -125 -121 0 -130 8 -130 125 0 117 9 125 130 125 77 0 93 -3 110 -20z m450 -105 c0 -30 -4 -55 -10 -55 -5 0 -10 18 -10 41 0 32 -3 40 -15 35 -18 -7 -20 5 -3 22 26 26 38 13 38 -43z m88 43 c17 -17 15 -73 -3 -88 -36 -30 -76 21 -56 73 11 29 39 35 59 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 230 c-27 -11 -31 -55 -9 -85 12 -16 12 -22 -1 -42 -13 -19 -13 -23 -1 -23 7 0 21 13 31 29 16 28 16 29 -5 43 -27 18 -19 68 12 68 18 0 20 -7 20 -70 0 -56 3 -70 15 -70 12 0 15 16 15 80 l0 80 -27 -1 c-16 0 -38 -4 -50 -9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764 176 c-7 -31 4 -68 19 -63 16 5 15 79 0 84 -7 3 -15 -7 -19 -21z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycounterDark);
export default __webpack_public_path__ + "static/media/cycounterDark.d0d1ea73a7ee2ddb4563c8e6dfe290d1.svg";
export { ForwardRef as ReactComponent };